<template>
  <div class="pa-2">
    <section class="stop-hierarchy-card">
      <draggable
        ref="drag"
        v-model="alocatedDeliveries"
        v-bind="dragOptions"
        multi-drag
        tag="div"
        selected-class="multi-drag"
        @add="onAdd"
      >
        <div class="pa-4">
          <v-card-text class="d-flex justify-space-between pa-0 pb-3" style="font-size: 1rem">
            <div class="d-flex">
              <div class="d-flex pr-1">
                <v-checkbox v-model="localSelected" class="checkbox-nfe ma-0 pa-0" hide-details></v-checkbox>
              </div>
              <div class="mr-4">
                <span class="font-weight-bold"> Parada: </span>
                <span class="font-weight-regular"> {{ stop.stopNumber }} </span>
              </div>
              <div class="mr-4">
                <span class="font-weight-bold">Destinatário: </span>
                <TruncateDataWithTooltip
                  :data="stop.nameRecipient"
                  :lengthDataToTruncate="truncateLimit"
                ></TruncateDataWithTooltip>
              </div>
              <div class="mr-4">
                <span class="font-weight-bold">Cidade: </span>
                <TruncateDataWithTooltip
                  :data="stop.nameCityRecipient"
                  :lengthDataToTruncate="truncateLimit"
                ></TruncateDataWithTooltip>
              </div>
            </div>
            <div class="d-flex">
              <v-icon v-if="isCollapsed" @click="isCollapsed = !isCollapsed">mdi-chevron-down</v-icon>
              <v-icon v-else @click="getDeliveriesByStop(true)">mdi-chevron-right</v-icon>
              <v-icon class="ml-2" @click="openDeleteDialog(stop.id)"> mdi-close </v-icon>
            </div>
          </v-card-text>
          <v-card-text class="d-flex pa-0">
            <v-col class="pa-0" cols="12" md="12">
              <span class="font-weight-bold text--secondary">Valor das Mercadorias: </span>
              <span class="font-weight-regular mr-4">{{ formatPrice(stop.totalPriceNfes) }}</span>
              <span class="font-weight-bold text--secondary">Frete embarcador: </span>
              <span class="font-weight-regular mr-4">{{ formatPrice(stop.totalPriceDeliveries) }}</span>
              <span class="font-weight-bold text--secondary">Peso: </span>
              <span class="font-weight-regular mr-4">{{ formatWeight(stop.weightDeliveries || 0) }}kg</span>
              <span class="font-weight-bold text--secondary">Quantidade de entregas: </span>
              <span class="font-weight-regular"> {{ stop?.amountDeliveries }} </span>
            </v-col>
          </v-card-text>
        </div>
        <v-data-table
          id="list02"
          class="w-100"
          v-if="isCollapsed"
          :headers="fileHeaders"
          :items="alocatedDeliveries"
          :items-per-page="alocatedDeliveries.length"
          :loading="isLoadingAlocated"
          loading-text="Carregando..."
          hide-default-footer
        >
          <template v-if="alocatedDeliveries.length > 0" v-slot:[`header.select`]="{}">
            <v-checkbox hide-details v-model="selectAll" class="pa-0 ma-0 ml-6"></v-checkbox>
          </template>
          <template #body="{}">
            <drag-table-alocated
              v-model="alocatedDeliveries"
              :stop="stop"
              :selectAll="selectAll"
              @update:allocated="unallocated"
              @update:selectAll="selectAll = $event"
              @loading:allocated="loadingAlocated"
            />
          </template>
        </v-data-table>
      </draggable>
    </section>

    <delete-confirm-dialog
      :isOpen.sync="isDeleteDialogOpen"
      :isConfirmBtnLoading="isDeleteButtonLoading"
      @confirmClick="deleteStop"
      title="Desfazer Parada"
      :body-text="confirmationText"
    />
  </div>
</template>

<script>
import DeleteConfirmDialog from '@/components/ConfirmDialog.vue';
import DragTableAlocated from '@/components/ManualBoardingImport/Stepper/Step4/DragTableAlocated.vue';
import TruncateDataWithTooltip from '@/components/Table/TruncateDataWithTooltip.vue';
import copyToClipboard from '@/utils/copyToClipboard';
import maskPrice from '@/utils/maskPrice';
import maskWeight from '@/utils/maskWeight';
import { mapActions } from 'vuex';
import draggable from 'vuedraggable';

export default {
  components: {
    DeleteConfirmDialog,
    DragTableAlocated,
    TruncateDataWithTooltip,
    draggable
  },
  props: {
    stop: {
      default: () => ({}),
      type: Object
    },
    selected: {
      type: Boolean,
      default: false
    }
  },
  data: () => ({
    isLoadingAlocated: false,
    isDeleteDialogOpen: false,
    isDeleteButtonLoading: false,
    isCollapsed: false,
    selectAll: false,
    selectedNfe: {},
    alocatedDeliveries: [],
    dragOptions: {
      animation: 150,
      group: 'deliveryAllocation',
      ghostClass: 'ghost',
      disabled: false,
      handle: 'none'
    },
    fileHeaders: [
      { value: 'select', text: '', sortable: false },
      { value: 'deliveryNumber', text: 'NÚMERO ENTREGA', sortable: true },
      { value: 'deliveryPrice', text: 'FRETE EMBARCADOR', sortable: true },
      { value: 'totalPriceNfes', text: 'PREÇO MERCADORIAS', sortable: true },
      { value: 'weight', text: 'PESO', sortable: true }
    ]
  }),
  computed: {
    localSelected: {
      get() {
        return this.selected;
      },
      set() {
        this.$emit('update:selected', this.stop.id);
      }
    },
    confirmationText() {
      if (this.getErrorNfeCount) {
        return 'Você confirma excluir essa parada?';
      } else {
        return 'Confirmar dasalocar as entregas e excluir essa parada?';
      }
    },
    truncateLimit() {
      const width = this.$vuetify.breakpoint.width;
      if (width < 1360) return 8;
      if (width < 1440) return 10;
      if (width < 1520) return 16;
      if (width < 1680) return 20;
      if (width < 1820) return 26;
      return 34;
    }
  },
  methods: {
    ...mapActions('ImportManualStopsStore', ['getDeliveriesByStopId', 'allocateDelivery']),
    async getDeliveriesByStop(collapsed = false) {
      this.isLoadingAlocated = true;
      try {
        if (collapsed) {
          this.isCollapsed = !this.isCollapsed;
        }
        const data = await this.getDeliveriesByStopId(this.stop.id);
        this.alocatedDeliveries = data;
      } catch (err) {
        console.error(err);
      } finally {
        this.isLoadingAlocated = false;
      }
    },
    loadingAlocated(loading) {
      this.alocatedDeliveries = [];
      this.isLoadingAlocated = loading;
    },
    openDeleteDialog() {
      this.isDeleteDialogOpen = true;
    },
    deleteStop() {
      this.$emit('removeStop', this.stop.id);
      this.isDeleteDialogOpen = false;
    },
    unallocated(value, msg) {
      this.$emit('update:allocated', value, msg);
      this.getDeliveriesByStop();
    },
    formatPrice(price) {
      return maskPrice(price);
    },
    formatWeight(price) {
      return maskWeight(price);
    },
    copy(str) {
      copyToClipboard(str);
    },

    async onAdd(e) {
      this.loadingAlocated(true);
      if (e.item._selected_items.length > 1) {
        const draggedItems = e.item._selected_items;
        await this.allocateDeliveryToStop(draggedItems);
      } else {
        await this.allocateDeliveryToStop(e.item._underlying_vm_);
      }
      await this.loadingAlocated(false);
      await this.getDeliveriesByStop();
      this.$emit('update:selectAll', false);
    },
    async allocateDeliveryToStop(deliveries) {
      try {
        let deliveriesIds;
        if (Array.isArray(deliveries)) {
          deliveriesIds = deliveries.map(({ id }) => id);
        } else {
          deliveriesIds = [deliveries.id];
        }
        const params = {
          id: this.stop.id,
          deliveriesIds: deliveriesIds
        };

        const response = await this.allocateDelivery(params);
        if (response.success) {
          this.unallocated('Entregas alocadas com sucesso!', true);
        } else {
          const draggedItemIndex = this.alocatedDeliveries.findIndex((item) => item === deliveries);
          this.alocatedDeliveries.splice(draggedItemIndex, 1);
          this.$emit(
            'update:allocated',
            response.errors[0] || 'Entregas com destinatário ou remetente distintos!',
            false
          );
        }
      } catch (err) {
        console.error(err);
      }
    }
  }
};
</script>

<style scoped>
* {
  transition: 0ms;
}
.ghost {
  display: none !important;
}
.stop-hierarchy-card {
  min-width: 560px;
  width: 100%;
  min-height: 90px;
  height: auto;
  border-radius: 3px;
  border: solid 1px #f1f1f1;
  box-shadow: 1px 4px 3px rgba(23, 23, 23, 0.28);
}
</style>
